// extracted by mini-css-extract-plugin
export default {"container":"SubInfo_container__k20zj","info":"SubInfo_info__f23rD","countdown":"SubInfo_countdown__zDR1F","seats":"SubInfo_seats__y43WD","btn":"SubInfo_btn__COLku"};